<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-two-thirds">
        <div class="box">
          <admin-box-item title="서비스 등록">
            <admin-form-item label="패키지 선택" desc="메뉴 구성을 위해서 패키지를 선택해주세요. 선택한 패키지는 메뉴에 반영됩니다.">
              <lp-check-group-boolean :list="allPackages" @selectedItem="selectPack"></lp-check-group-boolean>
            </admin-form-item>
            <admin-form-item label="상품">
              <lp-adm-drop-input :data.sync="listProduct"
                                 :selectVal="product"
                                 @onSelect="selectProduct"
                                 added_field="type"
                                 placeholder="검색 후 선택"
                                 width="250px"
                                 listAlign="center"
                                 style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>
            </admin-form-item>

            <admin-form-item label="가격" style="margin-top:20px">
            <span class="select">
              <select v-model="value.option_id"
                      @change="e => value.option_id=e.target.value">
                <option value="" disabled selected>선택</option>
                <option
                  v-for="(op, idx) in option" :key="idx"
                  :value="op.id">{{ op.label }}</option>
              </select>
            </span>
            </admin-form-item>

            <admin-form-item label="사용자(이메일 계정)" style="margin-top:20px">
              <lp-adm-drop-input :data.sync="listUser"
                                 :selectVal="username"
                                 @onSelect="selectUser"
                                 added_field="type"
                                 placeholder="검색 후 선택"
                                 width="250px"
                                 listAlign="center"
                                 style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>
            </admin-form-item>

            <!--<admin-form-item label="사용자 계정 비밀번호" style="margin-top:20px">
              <input class="input"
                     :value="value.password"
                     @input="e => value.password = e.target.value"
                     type="text" maxlength="30">
            </admin-form-item>-->

            <admin-form-item label="서비스명" style="margin-top:20px">
              <input class="input"
                     :value="value.service_name"
                     @input="e => value.service_name = e.target.value"
                     type="text" maxlength="30">
            </admin-form-item>

            <admin-form-item label="서비스 키(알파벳으로만 입력)" style="margin-top:20px">
              <input class="input"
                     :value="value.key"
                     @input="e => value.key = e.target.value"
                     style="width:140px"
                     type="text" maxlength="30"><span style="line-height:32px;margin-left:8px">.launchpack.co.kr</span>
            </admin-form-item>

            <admin-form-item label="도메인(제공받은게 있을때만 입력)" style="margin-top:20px">
              <input class="input"
                     :value="value.domain"
                     @input="e => value.domain = e.target.value"
                     type="text" maxlength="30">
            </admin-form-item>

            <admin-form-item label="데모 홈페이지" style="margin-top:20px">
              <input class="input"
                     :value="value.homepage"
                     @input="e=> value.homepage = e.target.value"
                     type="text">
            </admin-form-item>

            <admin-form-item label="데모 UI 빌더" style="margin-top:20px">
              <input class="input"
                     :value="value.ui"
                     @input="e=> value.ui = e.target.value"
                     type="text">
            </admin-form-item>

            <admin-form-item label="데모 백오피스" style="margin-top:20px">
              <input class="input"
                     :value="value.office"
                     @input="e=> value.office = e.target.value"
                     type="text">
            </admin-form-item>

          </admin-box-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LpAdmDropInput from "../../../module/common/LpAdmDropInput";
  import LpCheckGroupBoolean from "../../../module/common/LpCheckGroupBoolean";

  export default {
    components: {
      LpCheckGroupBoolean,
      LpAdmDropInput
    },

    data() {
      return {
        listProduct: [],
        listUser: [],
        listTheme: [],
        product: '',
        username: '',
        theme: '',
        value: {
          user_id: 0,
          option_id: 0,
          product_id: 0,
          service_name: '',
          key: '',
          domain: '',
          password: '',
          homepage: '',
          ui: '',
          office: '',
          request_type: 0
        },
        option: [],
        allPackages: []
      }
    },
    watch: {
      'value.product_id'(n){
        this.getOption(n);
      }
    },

    created() {
      //this.getProductList();
      this.getData();
      this.getAllPackages();
    },

    methods: {
      selectPack(res) {
        console.log(res)
      },
      getAllPackages() {
        this.$axios.get('public/service/packages/all').then(res=> {
          let packs = res.data;
          packs.forEach(pack => {
            this.allPackages.push({label: pack.name, name:pack.key, is_active: false})
          })
        })
      },
      selectProduct(res) {
        this.value.product_id = res.value;
        this.product = res.label;
      },
      selectTheme(res) {
        this.value.theme_id = res.value;
        this.theme = res.label;
      },
      selectUser(res) {
        this.value.user_id = res.value;
        this.username = res.label;
      },
      async getData() {
        await this.getProductList();
        await this.getUserList();
        this.getDetail();
      },
      getProductList() {
        this.$axios.get('public/product/whole').then(res=>{
          this.listProduct = res.data;
          this.getUserList();
        });
      },
      getUserList() {
        this.$axios.get('public/user/whole').then(res=>{
          this.listUser = res.data;
        });
      },
      getOption(id){
        this.$axios.get(`public/launchpack/theme/${id}/option`).then(res=>{
          if(res.status===200) {
            this.option = res.data;
          }
        })
      },
      getDetail() {
        if(this.$route.query.service_inquiry_id) {
          this.$axios.get(this.getUrl(`launchpack/service/inquiry/${this.$route.query.service_inquiry_id}`)).then(res=>{
            for(let j=0; j<this.listUser.length; j++) {
              if(this.listUser[j].value === res.data.user) {
                this.username = this.listUser[j].label;
                this.value.user_id = res.data.user;
              }
            }
          })
        }

        else if(this.$route.query.theme_request_id) {
          this.$axios.get(this.getUrl(`launchpack/theme/request/${this.$route.query.theme_request_id}`)).then(res=>{
            for(let j=0; j<this.listUser.length; j++) {
              if(this.listUser[j].value === res.data.user) {
                this.username = this.listUser[j].label;
                this.value.user_id = res.data.user;
              }
            }
          })
        }
      },
      saveData() {
        let err = '';
        if(this.value.product_id===0) err = '상품을 선택하세요.';
        else if(this.value.user_id===0) err = '사용자를 선택하세요.';
        else if(this.value.option_id===0) err = '가격을 선택하세요.';
        else if(this.value.service_name==='') err = '서비스명을 입력해주세요.';
        else if(this.value.key==='') err = '서비스키를 입력해주세요.';

        if(err){
          this.toast(err);
          return;
        }

        let value = this.cloneItem(this.value);
        let packs = [];
        this.allPackages.forEach(pack=> {
          if(pack.is_active) {
            packs.push(pack.name);
          }
        })
        value.packs = packs;

        this.$store.commit('setLoading', true);
        this.$axios.post('admin/launchpack/service', value).then(res=>{
          if(res.status===200 && res.data.detail==='success'){
            this.$store.commit('setLoading', false);
            this.toast('등록되었습니다.');
            this.$router.replace(this.getPath('launchpack/service'));
          }
        }).catch(error=>{
          this.$store.commit('setLoading', false);
          if(error.response.data.detail){
            this.toast(error.response.data.detail);
          }
          else {
            this.toast(error.response.data.message);
          }
        })

      }
    }
  }
</script>

<style scoped>

</style>
